"use strict";



//////////////////
// WEBPACK FOOTER
// ./~/memoizee/lib/registered-extensions.js
// module id = 651
// module chunks = 0